<script lang="ts" setup>
import { useTransition } from '../shared/composables/transition';
import type { TransitionProps } from '../types';

const props = defineProps<TransitionProps>();

const { classProps, componentIs, componentProps } = useTransition(() => props, {
  active: 'motion-safe:transition-[block-size] overflow-hidden',
  hidden: '[block-size:_0]',
  visible: '[block-size:_auto]',
});
</script>

<template>
  <Component v-bind="{ ...classProps, ...componentProps, ...$attrs }" :is="componentIs">
    <slot></slot>
  </Component>
</template>
